module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "box-holder row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border",
    on: {
      "click": function($event) {
        _vm.detailsOpen = !_vm.detailsOpen
      }
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Document details")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_c('i', {
    class: [_vm.detailsOpen ? 'open' : '', 'ion ion-chevron-down']
  })])]), _vm._v(" "), _c('div', {
    class: [_vm.detailsOpen ? 'open' : '', 'box-body']
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14)])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border",
    on: {
      "click": function($event) {
        _vm.contentOpen = !_vm.contentOpen
      }
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Content and Document Editor")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_c('i', {
    class: [_vm.contentOpen ? 'open' : '', 'ion ion-chevron-down']
  })])]), _vm._v(" "), _c('div', {
    class: [_vm.contentOpen ? 'open' : '', 'box-body']
  }, [_c('blockquote', [_vm._v("Documents")]), _vm._v(" "), _c('drop-file', {
    attrs: {
      "styles": {
        message: _vm.style
      },
      "parentId": _vm._uid,
      "uploadMessage": 'Click or drop files here'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row file-area"
  }, _vm._l((_vm.document.files), function(file, i) {
    return _c('div', {
      staticClass: "col-xs-6 col-sm-4 col-lg-3"
    }, [_c('file', {
      key: i,
      attrs: {
        "name": file,
        "index": i
      },
      on: {
        "remove-file": _vm.removeFile,
        "showing-file-options": _vm.closeFiles
      }
    })], 1)
  }), 0), _vm._v(" "), _c('hr'), _vm._v(" "), _c('blockquote', [_vm._v("Content editor")]), _vm._v(" "), _c('ckeditor', {
    style: ({
      marginBottom: '10px'
    }),
    attrs: {
      "config": _vm.config
    },
    model: {
      value: (_vm.testing),
      callback: function($$v) {
        _vm.testing = $$v
      },
      expression: "testing"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border",
    on: {
      "click": function($event) {
        _vm.accessOpen = !_vm.accessOpen
      }
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Access settings")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_c('i', {
    class: [_vm.accessOpen ? 'open' : '', 'ion ion-chevron-down']
  })])]), _vm._v(" "), _c('div', {
    class: [_vm.accessOpen ? 'open' : '', 'box-body']
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "group-access"
    }
  }, [_vm._v("Allow group access?")]), _vm._v(" "), _c('div', {
    staticClass: "material-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.test),
      expression: "test"
    }],
    attrs: {
      "id": "group-access",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.test) ? _vm._i(_vm.test, null) > -1 : (_vm.test)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.test,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.test = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.test = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.test = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label-success",
    attrs: {
      "for": "group-access"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "sub-group-access"
    }
  }, [_vm._v("Allow sub-group access?")]), _vm._v(" "), _c('div', {
    staticClass: "material-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.testTwo),
      expression: "testTwo"
    }],
    attrs: {
      "id": "sub-group-access",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.testTwo) ? _vm._i(_vm.testTwo, null) > -1 : (_vm.testTwo)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.testTwo,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.testTwo = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.testTwo = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.testTwo = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label-success",
    attrs: {
      "for": "sub-group-access"
    }
  })])]), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21)])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border",
    on: {
      "click": function($event) {
        _vm.miscOpen = !_vm.miscOpen
      }
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Thumbnail and Banner upload")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_c('i', {
    class: [_vm.miscOpen ? 'open' : '', 'ion ion-chevron-down']
  })])]), _vm._v(" "), _c('div', {
    class: [_vm.miscOpen ? 'open' : '', 'box-body']
  }, [_c('blockquote', [_vm._v("Add a thumbnail?")]), _vm._v(" "), _c('image-cropper', {
    attrs: {
      "styles": {
        message: _vm.style
      },
      "parentId": _vm._uid,
      "uploadMessage": 'Click or drop an image here'
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('blockquote', [_vm._v("Add a banner?")]), _vm._v(" "), _c('image-cropper', {
    attrs: {
      "styles": {
        message: _vm.style
      },
      "aspectRatio": 16 / 9,
      "parentId": _vm._uid,
      "uploadMessage": 'Click or drop an image here'
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "ref"
    }
  }, [_vm._v("Ref")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "ref"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "title"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "summary"
    }
  }, [_vm._v("Summary")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "summary"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "section"
    }
  }, [_vm._v("Section")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "section"
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("2")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "version"
    }
  }, [_vm._v("Version")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "version"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "sequence"
    }
  }, [_vm._v("Sequence")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "sequence"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "version-date"
    }
  }, [_vm._v("Version Date")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "version-date"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "author"
    }
  }, [_vm._v("Author")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "author"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "creator"
    }
  }, [_vm._v("Creator")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "creator"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "publish-date"
    }
  }, [_vm._v("Publish Date")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "publish-date"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "country"
    }
  }, [_vm._v("Specific to country")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "country"
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("2")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "policy"
    }
  }, [_vm._v("Policy")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "policy"
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("2")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "location"
    }
  }, [_vm._v("Specific to location")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "location"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "tags"
    }
  }, [_vm._v("Tags")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "tags"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "status"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "status"
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("2")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "entity"
    }
  }, [_vm._v("Entity")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "entity"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "sub-group"
    }
  }, [_vm._v("Sub-Group")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "sub-group"
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("2")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "business-unit"
    }
  }, [_vm._v("Business Unit")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "business-unit"
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("2")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "employee-class"
    }
  }, [_vm._v("Employee Class")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "employee-class"
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("2")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "grade"
    }
  }, [_vm._v("Grade")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "grade"
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("2")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "roles"
    }
  }, [_vm._v("Roles")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "roles"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "service-provider"
    }
  }, [_vm._v("Service Provider")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "service-provider"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cf57e414"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/library/components/LibraryDocument.vue
// module id = 2282
// module chunks = 1